// src/pages/Admin.jsx
import React, { useState, useEffect } from 'react';
import { meetingsAPI } from '../services/apiService';
import CreateMeeting from '../components/admin/CreateMeeting';
import MeetingsList from '../components/admin/MeetingsList';
import AdminManagement from '../components/admin/AdminManagement';
import styles from './Admin.module.css';
import { v4 as uuidv4 } from 'uuid';


const Admin = () => {
    const [activeTab, setActiveTab] = useState('meetings');
    const [meetings, setMeetings] = useState([]);

    useEffect(() => {
        const fetchMeetings = async () => {
            try {
                const response = await meetingsAPI.getMeetings();
                setMeetings(response);
            } catch (error) {
                console.error('Failed to fetch meetings:', error);
            }
        };

        fetchMeetings();
    }, []);

    const handleMeetingUpdated = async (updatedMeeting) => {
        try {
            const response = await meetingsAPI.updateMeeting(updatedMeeting.id, updatedMeeting);
            const updatedMeetings = meetings.map(meeting =>
                meeting.id === updatedMeeting.id ? response : meeting
            );
            setMeetings(updatedMeetings);
        } catch (error) {
            console.error('Failed to update meeting:', error);
        }
    };

    const handleMeetingDeleted = async (meetingId) => {
        try {
            await meetingsAPI.deleteMeeting(meetingId);
            setMeetings(meetings.filter(meeting => meeting.id !== meetingId));
        } catch (error) {
            console.error('Failed to delete meeting:', error);
        }
    };

    return (
        <div className={styles.pageContainer}>
            <div className={styles.adminContainer}>
                <header className={styles.header}>
                    <div className={styles.headerContent}>
                        <h1>Events Dashboard</h1>
                        <p className={styles.headerDescription}>Create and Manage team events</p>
                    </div>
                    <nav className={styles.navigation}>
                        <div className={styles.tabs}>
                            <button
                                className={`${styles.tab} ${activeTab === 'meetings' ? styles.active : ''}`}
                                onClick={() => setActiveTab('meetings')}
                            >
                                Manage Events
                            </button>
                            <button
                                className={`${styles.tab} ${activeTab === 'create' ? styles.active : ''}`}
                                onClick={() => setActiveTab('create')}
                            >
                                Create Events
                            </button>
                            <button
                                className={`${styles.tab} ${activeTab === 'admins' ? styles.active : ''}`}
                                onClick={() => setActiveTab('admins')}
                            >
                                Manage Admins
                            </button>
                        </div>
                    </nav>
                </header>

                <main className={styles.mainContent}>
                    <div className={styles.contentWrapper}>
                        <div className={styles.content}>
                            {activeTab === 'create' ? (
                                <section className={styles.createSection}>
                                    <CreateMeeting
                                        onMeetingCreated={async (newMeeting) => {
                                    
                                            try {
                                                const meetingWithId = {
                                                    id: uuidv4(),
                                                    title: newMeeting.title,
                                                    description: newMeeting.description,
                                                    date: newMeeting.date,
                                                    start_time: newMeeting.startTime,
                                                    end_time: newMeeting.endTime,
                                                    teams_link: newMeeting.teamsLink,
                                                    id_meeting: newMeeting.id_meeting,
                                                    max_participants: newMeeting.maxParticipants,
                                                    rsvp_list: newMeeting.rsvpList,
                                                    organizer: {
                                                        email: newMeeting.organizer_email,
                                                        name: newMeeting.organizer_name || 'Admin',
                                                    },
                                                    accessToken: newMeeting.accessToken,
                                                    refreshToken: " ",
                                                    tokenExpiry: "",
                                                    status: "active"
                                                };

                                                const response = await meetingsAPI.createMeeting(meetingWithId);
                                                setMeetings([...meetings, response]);
                                                setActiveTab('meetings');
                                            } catch (error) {
                                                console.error('Failed to create meeting:', error);
                                            }
                                        }}
                                    />
                                </section>
                            ) : activeTab === 'admins' ? (
                                <section className={styles.adminSection}>
                                    <AdminManagement />
                                </section>
                            ) : (
                                <section className={styles.listSection}>
                                    <MeetingsList
                                        meetings={meetings}
                                        onMeetingUpdated={handleMeetingUpdated}
                                        onMeetingDeleted={handleMeetingDeleted}
                                    />
                                </section>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Admin;